import { alpha } from '@mui/material/styles';

function createGradient(color1: string, color2: string) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// GREY SCALE
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8),
};

// PRIMARY COLORS 
const PRIMARY = {
  lighter: '#E6E6E6',
  light: '#A6A6A6',
  main: '#000000',
  dark: '#1A1A1A',
  darker: '#0D0D0D',
  contrastText: '#FFFFFF',
};

// SECONDARY
const SECONDARY = {
  lighter: '#E6E6E6',
  light: '#A6A6A6',
  main: '#000000',
  dark: '#1A1A1A',
  darker: '#0D0D0D',
  contrastText: '#FFFFFF',
};

// // PRIMARY COLORS 
// const PRIMARY = {
//   lighter: '#aa7c70',
//   light: '#8e5040',
//   main: '#722410',
//   dark: '#5b1d0d',
//   darker: '#44160a',
//   contrastText: '#fff',
// };

// // SECONDARY
// const SECONDARY = {
//   lighter: '#aa7c70',
//   light: '#8e5040',
//   main: '#722410',
//   dark: '#5b1d0d',
//   darker: '#44160a',
//   contrastText: '#fff',
// };

// // PRIMARY COLORS (Gradient: Cyan → Purple)
// const PRIMARY = {
//   lighter: '#E0F7FF', // very light cyan
//   light: '#00C2FF', // cyan
//   main: '#9C4DFF', // purple
//   dark: '#6A00FF', // deep purple
//   darker: '#4B0082', // indigo shade
//   contrastText: '#fff',
// };

// // SECONDARY (can stay as is or softer blue)
// const SECONDARY = {
//   lighter: '#EBD6FF',
//   light: '#C084FF',
//   // main: '#9C4DFF',
//   main:'#AF52DE',
//   dark: '#6A00FF',
//   darker: '#3A0073',
//   contrastText: '#fff',
// };

// INFO, SUCCESS, WARNING, ERROR (keep defaults or adjust later if needed)
const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  // main: '#1890FF',
  main: '#007AFF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  // main: '#54D62C',
  main: '#34C759',
  dark: '#229A16',
  
  darker: '#08660D',
  contrastText: GREY[800],
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  // main: '#FFC107',
  main:"#FF9500",
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

// GRADIENTS
const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main), // cyan → purple
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
  sidePanel:
    'linear-gradient(0deg,rgba(136, 216, 252, 1) 0%, rgba(212, 240, 252, 1) 48%, rgba(255, 255, 255, 1) 100%)',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  text: {
    primary: GREY[800],
    secondary: '#93989F',
    disabled: GREY[500],
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[200],
    mainBackground: '#f2f2f2', // matches app background
    // sidePanelBackground: GRADIENTS.sidePanel,
    tableHeaderBackground: 'rgba(238, 230, 255, 1)',
  },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
